import React, { Fragment } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from './ui/Breadcrumb';
export function RouteBreadcrumb() {
  const location = useLocation();
  const paths = location.pathname.split('/').filter(Boolean);
  if (paths.length === 0) return null;
  return <Breadcrumb data-id="element-116">
      <BreadcrumbList data-id="element-117">
        {paths.map((path, index) => {
        const isLast = index === paths.length - 1;
        const to = `/${paths.slice(0, index + 1).join('/')}`;
        // Format path segment: capitalize and replace dashes/underscores
        const formattedPath = path.replace(/[-_]/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
        return <Fragment key={path} data-id="element-118">
              <BreadcrumbItem data-id="element-119">
                {isLast ? <BreadcrumbPage data-id="element-120">{formattedPath}</BreadcrumbPage> : <BreadcrumbLink asChild data-id="element-121">
                    <Link to={to} data-id="element-122">{formattedPath}</Link>
                  </BreadcrumbLink>}
              </BreadcrumbItem>
              {!isLast && <BreadcrumbSeparator data-id="element-123" />}
            </Fragment>;
      })}
      </BreadcrumbList>
    </Breadcrumb>;
}